import React from 'react';
import IcClose from '@/assets/icons/ic-x-close.svg';
import styles from './StanNotification.module.css';
import { cn, createIconElement, stanAnalytics } from '@/lib';
import { toast } from 'react-toastify';

// Icons
import CheckCircleIcon from '@/assets/icons/ic-check-circle.svg';
import WarningCircleIcon from '@/assets/icons/ic-warning-circle.svg';
import InfoIcon from '@/assets/icons/ic-info-circle.svg';
import { useUser } from '@/queries/useUser';

export interface StanNotificationToastProps {
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    text?: string;
}

const notificationConfig = {
    info: {
        class: 'notify-info',
        icon: InfoIcon,
    },
    warning: {
        class: 'notify-warning',
        icon: WarningCircleIcon,
    },
    success: {
        class: 'notify-success',
        icon: CheckCircleIcon,
    },
    error: {
        class: 'notify-error',
        icon: WarningCircleIcon,
    },
};

export const StanNotification: React.FC<StanNotificationToastProps> = ({ type = 'info', title, text }) => {
    const { user } = useUser();

    const config = notificationConfig[type] || notificationConfig.info;
    const IconComponent = config.icon;
    const BareIcon = createIconElement(IconComponent, { className: 'size-6' });
    const CloseIcon = createIconElement(IcClose);
    const handleClose = () => {
        stanAnalytics('admin-notification-closed', {
            meta: {
                user_id: user?.user_id,
                username: user?.username,
            },
            props: {
                notification_type: type,
                notification_title: title,
            },
        });
        toast.dismiss();
    };

    return (
        <div className={`${styles.stanNotification} ${styles[config.class]}`}>
            <div className={`${styles.stanIcon} ${styles[config.class]}`}>{BareIcon}</div>

            <div className={styles.notifyContent}>
                <span className={styles.notifyContentTitle}>{title}</span>
                {text && <span className={cn(styles.notifyContentText, 'text-brand-200')}>{text}</span>}
            </div>

            <div className={`${styles.stanIcon}} text-brand-soft cursor-pointer`} onClick={handleClose}>
                {CloseIcon}
            </div>
        </div>
    );
};
